<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <!-- Seção: Dados Financeiros -->
    <section class="form-section">
      <div class="form-section-header">
        <i class="fa fa-dollar"></i>
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Dados financeiros'"
          :Sessao="'Dados Financeiros'"
          :SubSessao="'Dados Financeiros'"
        />
      </div>
      <div class="form-section-content">
        <div class="form-subsection">
          <!-- Campos dinâmicos baseados no tipo de cliente -->

          <!-- Layout exclusivo para Institucional -->
          <div v-if="isInstitucional">
            <div class="form-grid-1 mb-4">
              <div class="form-field">
                <label class="form-field-label form-field-label-required">
                  Patrimônio líquido
                </label>
                <input
                  v-model="localData.PatrimonioLiquido"
                  @change="salvarAlteracoesLocalmente"
                  @blur="() => focusOut('PatrimonioLiquido')"
                  @focus="() => focusIn('PatrimonioLiquido')"
                  @input="(event) => handleInput(event, 'PatrimonioLiquido')"
                  class="field"
                  type="text"
                  placeholder="R$ 0,00"
                />
                <p v-if="camposObrigatorios.erroPatrimonioLiquido" class="form-field-error">
                  Campo obrigatório.
                </p>
              </div>
            </div>
            <div class="form-grid-1 mb-4">
              <div class="form-field">
                <label class="form-field-label form-field-label-required">
                  Data base do patrimônio líquido
                </label>
                <input
                  v-model="localData.DataBasePatrimonioLiquido"
                  @change="salvarAlteracoesLocalmente"
                  class="field"
                  type="date"
                />
                <p v-if="camposObrigatorios.erroDataBasePatrimonioLiquido" class="form-field-error">
                  Campo obrigatório.
                </p>
              </div>
            </div>
          </div>

          <!-- Layout especial para Fundos: 3 campos em linha -->
          <div v-else-if="tipoCliente === TIPO_CLIENTE.FUNDOS" class="form-grid-3 mb-4">
            <div
              v-for="campo in camposConfig.campos"
              :key="campo.key"
              class="form-field"
            >
              <label
                class="form-field-label"
                :class="{ 'form-field-label-required': campo.obrigatorio }"
              >
                {{ campo.label }}
              </label>
              <input
                v-model="localData[campo.key]"
                @change="salvarAlteracoesLocalmente"
                @blur="() => focusOut(campo.key)"
                @focus="() => focusIn(campo.key)"
                @input="(event) => handleInput(event, campo.key)"
                class="field"
                type="text"
                placeholder="R$ 0,00"
              />
              <p
                v-if="campo.obrigatorio && mostrarHintZero(campo)"
                class="text-xs mt-1 dark:text-gray-400"
              >
                (caso não possua, incluir o valor '0')
              </p>
              <p
                v-if="camposObrigatorios['erro' + campo.key]"
                class="form-field-error"
              >
                Campo obrigatório.
              </p>
            </div>
          </div>

          <!-- Layout padrão para PF e PJ -->
          <div v-else v-for="campo in camposConfig.campos" :key="campo.key">
            <!-- Campo com radio base (apenas PF - OutrosRendimentos) -->
            <div v-if="campo.temBase" class="form-grid-1 mb-4">
              <div class="form-field">
                <label class="form-field-label"
                  >{{ campo.label }}{{ campo.obrigatorio ? "*" : "" }}</label
                >
                <div class="flex gap-4 items-center mb-2">
                  <div class="flex items-center">
                    <input
                      type="radio"
                      value="Base anual"
                      v-model="localData.BaseOutrosRendimentos"
                      @change="salvarAlteracoesLocalmente"
                      class="mr-2"
                    />
                    <label class="mb-0">Base anual</label>
                  </div>
                  <div class="flex items-center">
                    <input
                      type="radio"
                      value="Base mensal"
                      v-model="localData.BaseOutrosRendimentos"
                      @change="salvarAlteracoesLocalmente"
                      class="mr-2"
                    />
                    <label class="mb-0">Base mensal</label>
                  </div>
                </div>
                <input
                  v-model="localData[campo.key]"
                  @change="salvarAlteracoesLocalmente"
                  @blur="() => focusOut(campo.key)"
                  @focus="() => focusIn(campo.key)"
                  @input="(event) => handleInput(event, campo.key)"
                  class="field"
                  type="text"
                  placeholder="R$ 0,00"
                />
                <p
                  v-if="campo.obrigatorio && mostrarHintZero(campo)"
                  class="text-xs mt-1 dark:text-gray-400"
                >
                  (caso não possua, incluir o valor '0')
                </p>
                <p
                  v-if="camposObrigatorios['erro' + campo.key]"
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
            </div>

            <!-- Campo padrão sem especificação -->
            <div v-else-if="!campo.temEspecificacao" class="form-grid-1 mb-4">
              <div class="form-field">
                <label
                  class="form-field-label"
                  :class="{ 'form-field-label-required': campo.obrigatorio }"
                >
                  {{ campo.label }}
                </label>
                <input
                  v-model="localData[campo.key]"
                  @change="salvarAlteracoesLocalmente"
                  @blur="() => focusOut(campo.key)"
                  @focus="() => focusIn(campo.key)"
                  @input="(event) => handleInput(event, campo.key)"
                  class="field"
                  type="text"
                  placeholder="R$ 0,00"
                />
                <p
                  v-if="campo.obrigatorio && mostrarHintZero(campo)"
                  class="text-xs mt-1 dark:text-gray-400"
                >
                  (caso não possua, incluir o valor '0')
                </p>
                <p
                  v-if="camposObrigatorios['erro' + campo.key]"
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
            </div>

            <!-- Campo com especificação (apenas PF) -->
            <div v-else class="form-grid-1 mb-4">
              <div class="form-field">
                <label
                  class="form-field-label"
                  :class="{ 'form-field-label-required': campo.obrigatorio }"
                >
                  {{ campo.label }}
                </label>
                <input
                  v-model="localData[campo.key]"
                  @change="salvarAlteracoesLocalmente"
                  @blur="() => focusOut(campo.key)"
                  @focus="() => focusIn(campo.key)"
                  @input="(event) => handleInput(event, campo.key)"
                  class="field"
                  type="text"
                  placeholder="R$ 0,00"
                />
                <p
                  v-if="campo.obrigatorio && mostrarHintZero(campo)"
                  class="text-xs mt-1 dark:text-gray-400"
                >
                  (caso não possua, incluir o valor '0')
                </p>
                <p
                  v-if="camposObrigatorios['erro' + campo.key]"
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
              <div class="form-field mt-2">
                <label class="form-field-label">Especifique</label>
                <textarea
                  v-model="localData[campo.key + 'Especificacao']"
                  @change="salvarAlteracoesLocalmente"
                  class="field"
                  rows="3"
                  placeholder="Descreva detalhes..."
                ></textarea>
              </div>
            </div>

            <!-- Campo de especificação para OutrosRendimentos (PF) -->
            <div
              v-if="
                campo.key === 'OutrosRendimentos' &&
                tipoCliente === TIPO_CLIENTE.PESSOA_FISICA
              "
              class="form-grid-1 mb-4"
            >
              <div class="form-field">
                <label class="form-field-label"
                  >Especifique outros rendimentos</label
                >
                <textarea
                  v-model="localData.OutrosRendimentosEspecificacao"
                  @change="salvarAlteracoesLocalmente"
                  class="field"
                  rows="3"
                  placeholder="Descreva os outros rendimentos..."
                ></textarea>
              </div>
            </div>
          </div>

          <!-- Campo calculado (apenas PF - PatrimonioTotal) -->
          <div v-if="camposConfig.calculoAutomatico" class="form-grid-1 mb-4">
            <div class="form-field">
              <label class="form-field-label">{{
                camposConfig.campoCalculado
              }}</label>
              <input
                v-model="localData[camposConfig.campoCalculado]"
                class="field"
                type="text"
                disabled
                placeholder="R$ 0,00"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <ModalAlerta
      :mostrar="modalAlerta.mostrar"
      :tipo="modalAlerta.tipo"
      :titulo="modalAlerta.titulo"
      :mensagem="modalAlerta.mensagem"
      @fechar="modalAlerta.mostrar = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  formatCurrency,
  parseCurrency,
  parseCurrencyToNumber,
} from "@/utils/formUtils";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";

export default {
  name: "DadosFinanceirosShared",
  components: { LabelDisclaimer, ModalAlerta },
  props: {
    Edicao: Boolean,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
    tipoCliente() {
      return this.user?.TipoCliente;
    },

    nomeEmpresa() {
      return process.env.VUE_APP_NOME_EMPRESA;
    },

    isInstitucional() {
      return this.tipoCliente === TIPO_CLIENTE.INSTITUCIONAL;
    },

    infoPorTipo() {
      const getters = {
        [TIPO_CLIENTE.PESSOA_FISICA]: "GET_PF_INFO_FINANCEIRAS",
        [TIPO_CLIENTE.PESSOA_JURIDICA]: "GET_PJ_INFO_FINANCEIRA_EMPRESA",
        [TIPO_CLIENTE.FUNDOS]: "GET_FI_INFO_FINANCEIRO",
        [TIPO_CLIENTE.INSTITUCIONAL]: "GET_PJ_INFO_FINANCEIRA_EMPRESA",
      };
      return this.$store.getters[getters[this.tipoCliente]] || {};
    },

    camposConfig() {
      const configs = {
        [TIPO_CLIENTE.PESSOA_FISICA]: {
          campos: [
            {
              key: "RemuneracaoMensal",
              label: "Remuneração mensal",
              obrigatorio: false,
            },
            {
              key: "OutrosRendimentos",
              label: "Outros rendimentos",
              obrigatorio: false,
              temBase: true,
            },
            {
              key: "BensImoveis",
              label: "Bens imóveis",
              obrigatorio: true,
              temEspecificacao: true,
            },
            {
              key: "BensMoveis",
              label: "Bens móveis",
              obrigatorio: true,
              temEspecificacao: true,
            },
            {
              key: "PatrimonioLiquido",
              label: "Patrimônio líquido em aplicações financeiras",
              obrigatorio: true,
              temEspecificacao: true,
            },
          ],
          calculoAutomatico: true,
          campoCalculado: "PatrimonioTotal",
        },
        [TIPO_CLIENTE.PESSOA_JURIDICA]: {
          campos: [
            {
              key: "FaturamentoMedioMensal",
              label: "Faturamento médio mensal",
              obrigatorio: true,
            },
            {
              key: "CapitalSocial",
              label: "Capital social",
              obrigatorio: true,
            },
            {
              key: "PatrimonioAplicacoesFinanceiras",
              label: "Patrimônio em aplicações financeiras",
              obrigatorio: false,
            },
            {
              key: "PatrimonioLiquido",
              label: "Patrimônio líquido",
              obrigatorio: true,
              validacaoEspecial: "configZero",
            },
            {
              key: "ValorBensMoveisImoveis",
              label: "Valor aproximado de bens móveis e imóveis",
              obrigatorio: false,
            },
          ],
          calculoAutomatico: false,
        },
        [TIPO_CLIENTE.FUNDOS]: {
          campos: [
            {
              key: "FaturamentoMedioMensal",
              label: "Faturamento médio mensal",
              obrigatorio: true,
            },
            { key: "Patrimonio", label: "Patrimônio", obrigatorio: true },
            {
              key: "CapitalSocial",
              label: "Capital social",
              obrigatorio: true,
            },
          ],
          calculoAutomatico: false,
        },
        [TIPO_CLIENTE.INSTITUCIONAL]: {
          campos: [
            {
              key: "PatrimonioLiquido",
              label: "Patrimônio líquido",
              obrigatorio: true,
            },
          ],
          calculoAutomatico: false,
        },
      };
      return configs[this.tipoCliente];
    },

    storeMutations() {
      return {
        [TIPO_CLIENTE.PESSOA_FISICA]: "SET_PF_SALVAR_INFO_FINANCEIRAS",
        [TIPO_CLIENTE.PESSOA_JURIDICA]: "SET_PJ_SALVAR_INFO_FINANCEIRO",
        [TIPO_CLIENTE.FUNDOS]: "SET_FI_SALVAR_INFO_FINANCEIRO",
        [TIPO_CLIENTE.INSTITUCIONAL]: "SET_PJ_SALVAR_INFO_FINANCEIRO",
      };
    },

    proximaEtapaNumero() {
      const etapas = {
        [TIPO_CLIENTE.PESSOA_FISICA]: 3,
        [TIPO_CLIENTE.PESSOA_JURIDICA]: this.nomeEmpresa?.toUpperCase().includes("GENIAL")
          ? 5
          : 4,
        [TIPO_CLIENTE.FUNDOS]: 4,
        [TIPO_CLIENTE.INSTITUCIONAL]: this.nomeEmpresa?.toUpperCase().includes("GENIAL")
          ? 5
          : 4,
      };
      return etapas[this.tipoCliente];
    },

    configPatrimonioLiquido() {
      if (this.tipoCliente !== TIPO_CLIENTE.PESSOA_JURIDICA) return null;

      const config =
        this.getConfiguracoes("Campo Patrimônio liquido não aceita zero")
          ?.Valor ?? "N";

      return config && config === "S";
    },
  },
  data() {
    return {
      TIPO_CLIENTE,
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      permitirAvancar: false,
      camposObrigatorios: {},
      localData: this.initializeLocalData(),
    };
  },
  watch: {
    infoPorTipo: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.localData = { ...this.localData, ...newVal };
        }
      },
      immediate: true,
    },
    "localData.BensImoveis"() {
      if (this.camposConfig.calculoAutomatico) {
        this.calcularPatrimonioTotal();
      }
    },
    "localData.BensMoveis"() {
      if (this.camposConfig.calculoAutomatico) {
        this.calcularPatrimonioTotal();
      }
    },
    "localData.PatrimonioLiquido"() {
      if (this.camposConfig.calculoAutomatico) {
        this.calcularPatrimonioTotal();
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("FETCH_VERIFICAR_DISPENSA_QUESTIONARIO");
    this.validarFormulario(false);
  },
  methods: {
    initializeLocalData() {
      const data = {
        Guid: "",
        BaseOutrosRendimentos: "Base anual",
      };

      // Inicializar todos os campos do config
      this.camposConfig?.campos.forEach((campo) => {
        data[campo.key] = "";
        if (campo.temEspecificacao) {
          data[campo.key + "Especificacao"] = "";
        }
      });

      if (this.camposConfig?.calculoAutomatico) {
        data[this.camposConfig.campoCalculado] = "";
      }

      // Especificações PF
      if (this.tipoCliente === TIPO_CLIENTE.PESSOA_FISICA) {
        data.OutrosRendimentosEspecificacao = "";
      }

      data.DataBasePatrimonioLiquido = "";

      return data;
    },

    calcularPatrimonioTotal() {
      if (this.tipoCliente !== TIPO_CLIENTE.PESSOA_FISICA) return;

      const bensImoveis = parseCurrencyToNumber(this.localData.BensImoveis);
      const bensMoveis = parseCurrencyToNumber(this.localData.BensMoveis);
      const patrimonioLiquido = parseCurrencyToNumber(
        this.localData.PatrimonioLiquido,
      );

      const total = bensImoveis + bensMoveis + patrimonioLiquido;
      this.localData.PatrimonioTotal = formatCurrency(total);
    },

    isNumeroValidoObrigatorio(nomeCampo) {
      const valor = parseCurrencyToNumber(this.localData[nomeCampo]);
      return valor !== null && valor !== undefined && !isNaN(valor);
    },

    focusIn(nomeCampo) {
      this.localData[nomeCampo] = parseCurrency(this.localData[nomeCampo]);
    },

    focusOut(nomeCampo) {
      const valorNumerico = parseCurrencyToNumber(this.localData[nomeCampo]);
      this.localData[nomeCampo] = formatCurrency(valorNumerico);
    },

    handleInput(event, nomeCampo) {
      let valor = event.target.value;
      valor = valor.replace(/[^\d]/g, "");
      if (valor === "") {
        this.localData[nomeCampo] = "";
      } else {
        const MAX = 9_999_999_999_999;
        const numero = Math.min(parseFloat(valor) / 100, MAX);
        this.localData[nomeCampo] = formatCurrency(numero);
      }
    },

    async validarFormulario(submeter) {
      // Guard: se dados financeiros não foram inicializados ainda, não pode validar
      if (!this.localData || Object.keys(this.localData).length === 0) {
        return false;
      }

      this.permitirAvancar = true;
      let nomeDoCampo = "";

      // Reset erros
      this.camposObrigatorios = {};

      // Validar campos obrigatórios
      if (this.isInstitucional) {
        // Institucional: apenas PatrimonioLiquido + DataBasePatrimonioLiquido
        if (!this.isNumeroValidoObrigatorio("PatrimonioLiquido")) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroPatrimonioLiquido = true;
            nomeDoCampo = "Patrimônio líquido";
          }
          this.permitirAvancar = false;
        }
        if (!this.localData.DataBasePatrimonioLiquido) {
          if (submeter && this.permitirAvancar) {
            this.camposObrigatorios.erroDataBasePatrimonioLiquido = true;
            nomeDoCampo = "Data base do patrimônio líquido";
          }
          this.permitirAvancar = false;
        }
      } else {
        for (const campo of this.camposConfig.campos) {
          if (!campo.obrigatorio) continue;

          // Validação especial para PJ - PatrimonioLiquido com config
          if (
            campo.validacaoEspecial === "configZero" &&
            this.configPatrimonioLiquido
          ) {
            const valor = parseCurrencyToNumber(this.localData[campo.key]);
            if (valor < 1) {
              if (submeter) {
                await this.$swal({
                  icon: "warning",
                  title: "Atenção",
                  text: `O campo ${campo.label} precisa ser igual ou superior a R$ 1,00.`,
                });
              }
              this.permitirAvancar = false;
              continue;
            }
          }

          // Validação padrão
          if (!this.isNumeroValidoObrigatorio(campo.key)) {
            if (submeter && this.permitirAvancar) {
              this.camposObrigatorios["erro" + campo.key] = true;
              nomeDoCampo = campo.label;
            }
            this.permitirAvancar = false;
          }
        }
      }

      // Alerta de campo não preenchido
      if (submeter && nomeDoCampo) {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Campo obrigatório",
          mensagem: `O campo ${nomeDoCampo} não foi informado corretamente, preencha a informação para avançar.`,
        };
      }

      // Confirmação se todos valores = 0 (apenas campos obrigatórios, não Institucional)
      if (!this.isInstitucional && this.permitirAvancar && submeter) {
        const todosZero = this.camposConfig.campos
          .filter((c) => c.obrigatorio)
          .every((c) => parseCurrencyToNumber(this.localData[c.key]) === 0);

        if (todosZero) {
          const result = await this.$swal({
            icon: "question",
            title: "Confirma os valores?",
            html: "Todos os valores obrigatórios foram preenchidos como <strong>R$ 0,00</strong>.<br/>Deseja prosseguir?",
            showCancelButton: true,
            confirmButtonText: "Sim, prosseguir",
            cancelButtonText: "Não, revisar",
          });
          return result.isConfirmed;
        }
      }

      return this.permitirAvancar;
    },

    async proximaEtapa() {
      if (await this.validarFormulario(true)) {
        const proximaEtapa = this.proximaEtapaNumero;
        this.$store.commit("SET_ETAPA_CADASTRO", proximaEtapa);
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.salvarInformacoes();
      }
    },

    formatarDadosParaAPI() {
      const dadosFormatados = { ...this.localData };

      // Converte todos os campos de moeda para números
      this.camposConfig.campos.forEach((campo) => {
        if (dadosFormatados[campo.key]) {
          const valorNumerico = parseCurrencyToNumber(
            dadosFormatados[campo.key],
          );
          dadosFormatados[campo.key] =
            valorNumerico !== null ? valorNumerico : 0;
        }
      });

      // Campo calculado (PatrimonioTotal em PF)
      if (
        this.camposConfig.calculoAutomatico &&
        dadosFormatados[this.camposConfig.campoCalculado]
      ) {
        const valorNumerico = parseCurrencyToNumber(
          dadosFormatados[this.camposConfig.campoCalculado],
        );
        dadosFormatados[this.camposConfig.campoCalculado] =
          valorNumerico !== null ? valorNumerico : 0;
      }

      return dadosFormatados;
    },

    salvarInformacoes() {
      const mutationKey = this.storeMutations[this.tipoCliente];
      const dadosFormatados = this.formatarDadosParaAPI();
      this.$store.commit(mutationKey, dadosFormatados);

      // Mutations específicas por tipo
        if (this.tipoCliente === TIPO_CLIENTE.PESSOA_FISICA) {
        this.$store.commit("SET_PF_SALVAR_INFO", true);
      } else if (this.tipoCliente === TIPO_CLIENTE.PESSOA_JURIDICA || this.tipoCliente === TIPO_CLIENTE.INSTITUCIONAL) {
        this.$store.commit("SET_PJ_SALVAR_INFO", true);
      } else if (this.tipoCliente === TIPO_CLIENTE.FUNDOS) {
        this.$store.commit("SET_FI_SALVAR_INFO", true);
      }
    },

    salvarAlteracoesLocalmente() {
      const mutationKey = this.storeMutations[this.tipoCliente];
      this.$store.commit(mutationKey, this.localData);
      this.validarFormulario(false);
    },

    mostrarHintZero(campo) {
      if (!campo.obrigatorio) return false;

      if (campo.validacaoEspecial === "configZero") {
        return !this.configPatrimonioLiquido;
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");
</style>
